import firebase from '../../../firebase'
import { getUsersAndOther } from '../../Conversations/middleware/utils'

var db = firebase.firestore();

export const makeContactRequestFire = async({username, contactInfo, userId} ,next) => {

  var matches = await checkContact({
    userId,
    username,
    contactInfo
  })

  var matchingProfiles = await checkProfiles(contactInfo)

  var [foundProfile] = matchingProfiles;

  console.log({
    matchingProfiles,
    foundProfile
  })

  if (matches.length > 0) {

    return 'already contacted'

  } else {

    return await sendContactRequest({
        username,
        contactInfo,
        userId,
        foundProfile
      })

  }

}

export const sendContactRequest = ({username, contactInfo, userId, foundProfile}) => {

  var sendContactRequestUrl = `https://us-central1-fire-jitsu-chat.cloudfunctions.net/sendJitsuChatContactRequest`

  return fetch(sendContactRequestUrl, {
    url: sendContactRequestUrl,
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      username,
      contactInfo,
      userId,
      foundProfile
    })
  })
    .then(response => response.json())

}

export const checkContact = ({username, contactInfo, userId}) => {
  // first check requesters conversation/contact list
  return db.collection("conversations")

    .where(`user-${userId}`, '==', true).get()

    .then(({docs}) => {

      var conversations = docs

        .map(doc => {
          return {
            id: doc.id,
            ...doc.data(),
            ...getUsersAndOther(userId, doc.data()),

          }
        })

      return conversations;

    })

    .then(conversations => {

      return conversations

        .filter(conversation => (conversation.other || conversation.waitingContactInfo))

        .map(conversation => {

          return getConversationContactData(conversation)

        })

    }) //creates promise list

    .then(conversationWithContactsPromises => {

      return Promise.all(conversationWithContactsPromises)

    })

    .then(conversationWithContacts => {

      return conversationWithContacts.filter(data => {

        return data.contactProfile.email == contactInfo

      })

    })

}


const checkProfiles = async(contactInfo) => {

  var fireProfiles = await db.collection('userProfiles')

  var emailMatches = await fireProfiles.where('email', '==', contactInfo).get()

  var phoneMatches = await fireProfiles.where('phone', '==', contactInfo).get()

  var usernameMatches = await fireProfiles.where('username', '==', contactInfo).get()

  return [
    ...emailMatches.docs.map(doc => doc.data()),
    ...phoneMatches.docs.map(doc => doc.data()),
    ...usernameMatches.docs.map(doc => doc.data()),
  ]

}


const getConversationContactData = (conversation) => {

  var {other, waitingContactInfo} = conversation

  if (other) {

    return db.collection("userProfiles").where('userId', '==', other)

      .get()

      .then(({docs}) => {
        var contactProfile = {}

        if (docs.length > 0) {
          contactProfile = docs[0]
        }

        return {
          conversation,
          contactProfile: {
            ...contactProfile.data(),
            conversationUid: conversation.id,
          }
        }

      })

      .catch(data => {

        return {

        }

      })

  } else if (waitingContactInfo) {

    return Promise.resolve({
      conversation,
      contactProfile: {
        email: waitingContactInfo
      }
    })
  }

}



// WEBPACK FOOTER //
// ./src/Components/AddContactPage/middleware/contact-request.js